import eventTracker, { LoggingAction } from "@/handle/newDataWareHose";
import { EVENT4URL } from ".";
// import eventTracker, { LoggingAction } from '@handle/newDataWareHose';
export const registerSuccessHandle = data => {
  const userData = data.data;
  eventTracker.loggingEvent(LoggingAction.REGISTER, {
    user_id: (userData === null || userData === void 0 ? void 0 : userData.userId) || ""
  });
  // eventTracker.loggingEvent(LoggingAction.REGISTRATION_POP_UP, {
  // 	user_id: userData?.userId || '',
  // 	isregister: 'register',
  // });
  eventTracker.updateChannel(location.search, true);
  eventTracker.deleteBaiduChannel();
};
export const loginSuccessHandle = data => {
  const userData = data.data;
  eventTracker.loggingEvent(LoggingAction.AUTOLOGIN, {
    user_id: (userData === null || userData === void 0 ? void 0 : userData.userId) || ""
  });
  // eventTracker.loggingEvent(LoggingAction.REGISTRATION_POP_UP, {
  // 	user_id: userData?.userId || '',
  // 	isregister: 'register',
  // });
  eventTracker.updateChannel(location.search, true);
  eventTracker.deleteBaiduChannel();
};
export const imageSuccessHandle = url => {
  const generateUrl = [EVENT4URL.generateSuccess, EVENT4URL.generateSuccess2];
  if (generateUrl.indexOf(url) !== -1) {
    let type = undefined;
    if (url === EVENT4URL.generateSuccess) {
      type = "test";
    } else if (url === EVENT4URL.generateSuccess2) {
      type = "generate";
    }
    eventTracker.loggingEvent(LoggingAction.GENERATE_BUTTON_CLICK, {
      type: type
    });
    return;
  }
};